import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesRepoOpenIDPageLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./openid'),
});

export default PipelinesRepoOpenIDPageLoadable;
